@if (header() || (!pagination() && showReset)) {
  <div class="d-flex gap-3 align-items-center justify-content-between">
    <h2 class="mb-0 header-top">
      @if (header()) {
        {{ header() }}
      } @else {
        &nbsp;
      }
    </h2>
    @if (!pagination()) {
      <ng-template [ngTemplateOutlet]="reset"></ng-template>
    }
  </div>
}
<div #agGrid class="ag-grid-wrapper">
  <ag-grid-angular
    class="ag-grid ag-theme-balham {{ gridCssClass() }}"
    [components]="components"
    [rowData]="initialRowData"
    [gridOptions]="gridOptions"
    [groupDefaultExpanded]="groupDefaultExpanded()"
    [rememberGroupStateWhenNewData]="rememberGroupStateWhenNewData()"
    [suppressScrollOnNewData]="suppressScrollOnNewData()"
    (cellClicked)="onCellClicked($event)"
    (cellValueChanged)="cellValueChanged($event)"
    (columnMoved)="saveState()"
    (columnPinned)="saveState()"
    (columnResized)="saveState()"
    (columnVisible)="saveState()"
    (filterChanged)="filterChanged()"
    (firstDataRendered)="onFirstDataRendered($event)"
    (gridReady)="gridReady($event)"
    (rowDataUpdated)="rowDataUpdated()"
    (rowDragMove)="onRowDragMove($event)"
    (rowSelected)="onRowSelected($event)"
    (sortChanged)="saveState()"
  >
  </ag-grid-angular>
</div>

@if (pagination()) {
  <ng-template [ngTemplateOutlet]="reset"></ng-template>
}

<ng-template #reset>
  @if (showReset) {
    <div class="d-flex gap-2 align-items-center reset-buttons" [class.reset-pagination]="pagination()">
      @if (showRowCount) {
        @if (filterCount) {
          <span class="text-muted small" i18n>Showing {{ displayedRowCount }} of {{ totalRowCount }}</span>
        } @else {
          <span class="text-muted small" i18n>{{ totalRowCount }} rows</span>
        }
      }
      <button type="button" class="btn btn-primary" (click)="resetColumns()">
        <div class="d-flex align-items-center gap-1">
          <i class="fa fa-undo"></i>
          <span i18n>Columns</span>
        </div>
      </button>
      <button
        type="button"
        class="btn"
        [class.btn-primary]="!filterCount"
        [class.btn-warning]="filterCount"
        (click)="resetFilters()"
      >
        <div class="d-flex align-items-center gap-1">
          <i class="fa fa-undo"></i>
          <span i18n>Filters</span>
          @if (filterCount) {
            <span class="badge bg-light text-dark">{{ filterCount }}</span>
          }
        </div>
      </button>
    </div>
  }
</ng-template>
